import { useTranslation } from "react-i18next";

const Phone = ({ loading, formik, getInputClasses }) => {
  const { t } = useTranslation();

  return (
    <div className="fv-row mb-10">
      <label className="form-label fs-6 fw-bolder text-dark">
        {t("auth:create_account.input.phone.label")}
      </label>
      <input
        disabled={loading}
        placeholder={t("auth:create_account.input.phone.placeholder")}
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
          "phone"
        )}`}
        name="phone"
        {...formik.getFieldProps("phone")}
      />
      {formik.touched.phone && formik.errors.phone ? (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">{formik.errors.phone}</div>
        </div>
      ) : null}
    </div>
  );
};

export default Phone;
